// Replaces the competitor theme's own scripts on copied pages (we never load theirs).
// 1. Their page scripts are tagged type="text/lazyload" and were started by their own loader. We run them the same
//    way: once the page has loaded, in page order, one after another. A script with a data-src loads that file:
//    their theme files come from window.COPY_JS (our copies, set by the layout), public CDNs load as is, anything
//    else is skipped.
// 2. FAQ rows (pre-landers): click the question to open/close its answer, as on their page.
(function () {
  var CDN = /^https:\/\/(cdn\.jsdelivr\.net|cdnjs\.cloudflare\.com|ajax\.googleapis\.com)\//;
  function srcFor(s) {
    var src = s.getAttribute('data-src') || '';
    if (!src) return '';
    var name = src.split('?')[0].split('/').pop();
    if (window.COPY_JS && window.COPY_JS[name]) return window.COPY_JS[name];
    if (window.COPY_JS_LOADED && window.COPY_JS_LOADED[name]) return 'skip';
    return CDN.test(src) ? src : 'skip';
  }
  function run(list, i) {
    if (i >= list.length) {
      // their scripts were written to run before the page finished loading; many wait for these signals, which
      // have already fired by now. Their own loader replays them after the lazy scripts; we do the same, once.
      if (!window.__copyReplayed) {
        window.__copyReplayed = true;
        document.dispatchEvent(new Event('DOMContentLoaded', { bubbles: true }));
        window.dispatchEvent(new Event('load'));
        document.dispatchEvent(new CustomEvent('asyncLazyLoad'));  // their speed loader's own 'done' signal
      }
      return;
    }
    var old = list[i], s = document.createElement('script'), src = srcFor(old);
    if (src === 'skip') return run(list, i + 1);
    if (src) {
      s.src = src;
      s.onload = s.onerror = function () { run(list, i + 1); };
      old.parentNode.replaceChild(s, old);
    } else {
      s.text = old.text;
      old.parentNode.replaceChild(s, old);
      run(list, i + 1);
    }
  }
  function start() { run(Array.prototype.slice.call(document.querySelectorAll('script[type="text/lazyload"]')), 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

document.addEventListener('click', function (e) {
  var q = e.target.closest('.el-question');
  if (!q) return;
  var a = q.nextElementSibling;
  if (!a || !a.classList.contains('el-answer')) return;
  var open = a.style.display !== 'none';
  a.style.display = open ? 'none' : '';
  q.classList.toggle('active', !open);
  q.parentElement.classList.toggle('active', !open);
});
